/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateSelector/view.blocks to change it.
import Date from './Date/index'
import NextDayAction from './NextDayAction/index'
import NextMonthAction from './NextMonthAction/index'
import PreviousDayAction from './PreviousDayAction/index'
import PreviousMonthAction from './PreviousMonthAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DateSelector({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/UpperSection/DateSelector"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DateSelector.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousMonthAction
  viewPath={`${viewPath}/PreviousMonthAction`}
/>
<PreviousDayAction
  viewPath={`${viewPath}/PreviousDayAction`}
/>
<Date
  viewPath={`${viewPath}/Date`}
/>
<NextDayAction
  viewPath={`${viewPath}/NextDayAction`}
/>
<NextMonthAction
  viewPath={`${viewPath}/NextMonthAction`}
/>
</div>
{children}
</React.Fragment>)
}